import { PayloadAction } from '@reduxjs/toolkit';

import { FontState } from 'editor/src/store/fonts/types';

const removeUploadedFontReducer = (state: FontState, action: PayloadAction<string>) => {
  state.uploadedFonts = state.uploadedFonts.filter((f) => f.fontFile !== action.payload);
};

export default removeUploadedFontReducer;
